(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["back-to-top"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const btn = document.getElementById('backToTopBtn');
    if (!btn) return;

    const circle = btn.querySelector('.progress-ring__circle');
    const radius = circle ? circle.r.baseVal.value : 18;
    const circumference = 2 * Math.PI * radius;

    if (circle) {
      circle.style.strokeDasharray = `${circumference} ${circumference}`;
      circle.style.strokeDashoffset = circumference;
    }

    function updateProgress() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      
      if (scrollTop > 300) {
        btn.classList.add('visible');
      } else {
        btn.classList.remove('visible');
      }

      if (scrollHeight > 0 && circle) {
        const progress = scrollTop / scrollHeight;
        const offset = circumference - (progress * circumference);
        circle.style.strokeDashoffset = offset;
      }
    }

    window.addEventListener('scroll', updateProgress, { passive: true });

    btn.addEventListener('click', function() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-bottom-nav"] && !Shopify.designMode) return;
  try {
    (function () {
    var STYLE_ID = 'nimizo-joy-wishlist-mobile-nav-style';
    var css = [
      'button{',
      'display:inline-flex!important;align-items:center!important;justify-content:center!important;',
      'width:22px!important;height:22px!important;padding:0!important;margin:0!important;',
      'border:none!important;border-radius:0!important;background:transparent!important;',
      'color:#64748B!important;cursor:pointer!important;box-sizing:border-box!important;',
      'box-shadow:none!important;min-width:0!important;min-height:0!important;',
      '--joy-wl-access-icon-color:#64748B!important;',
      '--joy-wl-access-badge-bg:var(--color-coral,#FF6B81)!important;',
      '--joy-wl-access-badge-color:#fff!important;',
      '}',
      '.Joy-Wishlist-AccessButton__Icon{display:flex!important;align-items:center!important;justify-content:center!important;line-height:0!important;}',
      '.Joy-Wishlist-AccessButton__Icon svg{width:22px!important;height:22px!important;display:block!important;}',
      '.Joy-Wishlist-AccessButton__Icon svg path{',
      'fill:none!important;stroke:#64748B!important;stroke-width:1.8!important;',
      '}',
      '.Joy-Wishlist-AccessButton__AddedItem{',
      'top:-5px!important;right:-8px!important;width:15px!important;height:15px!important;',
      'min-width:15px!important;border-radius:999px!important;',
      'background:linear-gradient(135deg,#FF6B81 0%,#FF526C 100%)!important;color:#fff!important;',
      'font-size:.62rem!important;font-weight:800!important;line-height:1!important;',
      'display:flex!important;align-items:center!important;justify-content:center!important;',
      'border:none!important;box-sizing:border-box!important;',
      'box-shadow:0 2px 6px rgba(255,107,129,.4)!important;',
      '}'
    ].join('');

    function styleMobileWishlist(host) {
      if (!host || !host.shadowRoot) return;
      if (!host.shadowRoot.getElementById(STYLE_ID)) {
        var style = document.createElement('style');
        style.id = STYLE_ID;
        style.textContent = css;
        host.shadowRoot.appendChild(style);
      }
    }

    function placeWishlistIcon() {
      var slot = document.querySelector('[data-mobile-wishlist-slot]');
      if (!slot) return;

      var inSlot = slot.querySelector('joy-wishlist-icon');
      if (!inSlot) {
        var nav = document.querySelector('.mobile-bottom-nav');
        var loose = nav && nav.querySelector(':scope > joy-wishlist-icon');
        if (loose) slot.appendChild(loose);
        inSlot = slot.querySelector('joy-wishlist-icon');
      }
      if (inSlot) styleMobileWishlist(inSlot);
    }

    placeWishlistIcon();
    document.addEventListener('DOMContentLoaded', placeWishlistIcon);
    var observer = new MutationObserver(function () { placeWishlistIcon(); });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["order-tracking"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const modal = document.getElementById('nimizoOrderTrack');
    const form = document.getElementById('nimizoOrderTrackForm');
    const courier = document.getElementById('orderTrackCourier');
    const trackId = document.getElementById('orderTrackId');
    if (!modal || !form) return;

    function openModal() {
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      if (courier) courier.focus();
    }

    function closeModal() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
    }

    document.addEventListener('click', function (e) {
      const openBtn = e.target.closest('[data-order-track-open]');
      if (openBtn) {
        e.preventDefault();
        openModal();
        return;
      }
      if (e.target.closest('[data-order-track-close]')) {
        closeModal();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const option = courier.options[courier.selectedIndex];
      const base = courier.value;
      const id = (trackId.value || '').trim();
      if (!base || !id) return;

      let url = base;
      if (base.includes('?')) {
        url = base + '&' + (option.dataset.param || 'cn') + '=' + encodeURIComponent(id);
      } else if (base.endsWith('/')) {
        url = base + encodeURIComponent(id);
      } else {
        url = base + '?' + (option.dataset.param || 'cn') + '=' + encodeURIComponent(id);
      }

      window.open(url, '_blank', 'noopener,noreferrer');
      closeModal();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
